import React, { useState } from "react";
// import { Link } from "react-router-dom";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import Slider2 from "./Slider2/Slider2";
import "./Restaurant.css";

const Restaurant = () => {
  const [moreDetails, setMoreDetails] = useState(false);
  const [moreDetails2, setMoreDetails2] = useState(false);
  const [moreDetails3, setMoreDetails3] = useState(false);

  const [moreDetails4, setMoreDetails4] = useState(false);

  const showMore = () => {
    setMoreDetails(!moreDetails);
    setMoreDetails2(false);
    setMoreDetails3(false);
    setMoreDetails4(false);
  };

  const showMore2 = () => {
    setMoreDetails2(!moreDetails2);
    setMoreDetails(false);
    setMoreDetails3(false);
    setMoreDetails4(false);
  };

  const showMore3 = () => {
    setMoreDetails3(!moreDetails3);
    setMoreDetails(false);
    setMoreDetails2(false);
    setMoreDetails4(false);
  };

  const showMore4 = () => {
    setMoreDetails4(!moreDetails4);
    setMoreDetails(false);
    setMoreDetails2(false);
    setMoreDetails3(false);
  };
  return (
    <div>
      <section className='hero restuarantPage  '>
        <div className='container restuarantPage'>
          <div className='row'>
            <div className='col-md-6'>
              <Slider2 />
            </div>
            <div className='col-md-6 images  '>
              <div className='copy'>
                {/* <div className="text-label">
                            Book A Hotel At Residency Hotels Limited     
                        </div> */}
                <div className='rest__headStyle'>
                  <div
                    className='text-hero-bold'
                    style={{ fontSize: "1.2em", fontWeight: "600" }}
                  >
                    Our Restaurant
                    <hr />
                  </div>
                  <div className='text-hero-regular'>
                    Residency Hotels Restaurant in Nigeria, offers a
                    diverse menu of Nigerian and international cuisine, making it
                    a popular choice for guests seeking a delightful dining
                    experience.
                  </div>
                </div>
                <div className='card-body '>
                  <p className='card-text'>
                    <ul className='list-group'>
                      <li
                        className='list-group-item d-flex justify-content-between align-items-center'
                        style={{ position: "relative" }}
                      >
                        Chairman's Fish
                        {moreDetails ? (
                          <AiOutlineMinus onClick={showMore} />
                        ) : (
                          <AiOutlinePlus onClick={showMore} />
                        )}
                      </li>
                      {moreDetails ? (
                        <div className='col-md-12 hide'>
                          Chairman's Fish typically consists of a whole fish,
                          such as tilapia or red snapper, that is marinated and
                          seasoned with a variety of herbs and spices. The fish
                          is usually grilled or fried to perfection, resulting
                          in a crispy and flavorful outer layer while retaining
                          its moistness on the inside.
                        </div>
                      ) : null}
                      <li className='list-group-item d-flex justify-content-between align-items-center'>
                        Isi Ewu
                        {moreDetails2 ? (
                          <AiOutlineMinus onClick={showMore2} />
                        ) : (
                          <AiOutlinePlus onClick={showMore2} />
                        )}
                      </li>
                      {moreDetails2 ? (
                        <div className='col-md-12 hide'>
                          Isi Ewu is a traditional Nigerian dish that is popular
                          in the Igbo culture. It is a delicacy made from goat
                          head, typically cooked with a variety of spices and
                          herbs. The dish is known for its rich and flavorful
                          taste, often accompanied by palm wine or other
                          refreshing drinks.
                        </div>
                      ) : null}
                      <li className='list-group-item d-flex justify-content-between align-items-center'>
                        Abacha
                        {moreDetails3 ? (
                          <AiOutlineMinus onClick={showMore3} />
                        ) : (
                          <AiOutlinePlus onClick={showMore3} />
                        )}
                      </li>
                      {moreDetails3 ? (
                        <div className='col-md-12 hide'>
                          Abacha, also known as African Salad, is a traditional
                          Nigerian dish that originated from the Igbo tribe. It
                          is made from dried and shredded cassava flakes, which
                          are then rehydrated and mixed with various ingredients
                          to create a flavorful and satisfying meal.
                        </div>
                      ) : null}
                      <li className='list-group-item d-flex justify-content-between align-items-center'>
                        Rice and Stew
                        {moreDetails4 ? (
                          <AiOutlineMinus onClick={showMore4} />
                        ) : (
                          <AiOutlinePlus onClick={showMore4} />
                        )}
                      </li>
                      {moreDetails4 ? (
                        <div className='col-md-12 hide'>
                          Rice and stew is a popular and versatile dish enjoyed
                          in many cultures around the world. It is a simple yet
                          satisfying combination of cooked rice and a flavorful
                          stew or sauce that can be customized with various
                          ingredients and spices.
                        </div>
                      ) : null}
                    </ul>
                  </p>
                </div>
                <p></p>{" "}
                {/* <div className="cta">
                           <Link to='/availablehotels'><a className='btn btn-primary shadow-none ' data-bs-toggle="modal" data-bs-target="#staticBackdrop"> Order For Food </a></Link> 
                           
                        </div>  */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* modal */}

      <div
        className='modal fade'
        id='staticBackdrop'
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabindex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-scrollable'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h1 className='modal-title fs-5' id='staticBackdropLabel'>
                Please Fill The Form Below
              </h1>
              <button
                type='button'
                className='btn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
              ></button>
            </div>
            <div className='modal-body '>
              {/* form */}

              <form>
                <div className='container-fluid'>
                  <div className='row'>
                    <div className='mb-3 col-md-6'>
                      <label for='exampleInputEmail1' className='form-label'>
                        Title
                      </label>
                      <select
                        className='form-select form-control'
                        aria-label='Default select example'
                      >
                        <option selected disabled>
                          Open this select menu
                        </option>
                        <option value='Mr'>Mr</option>
                        <option value='Mrs'>Mrs</option>
                        <option value='Dr'>Dr</option>
                        <option value='Chief'>Chief</option>
                      </select>
                    </div>

                    <div className='mb-3 col-md-6'>
                      <label for='exampleInputEmail1' className='form-label'>
                        Gender
                      </label>
                      <select
                        className='form-select form-control'
                        aria-label='Default select example'
                      >
                        <option selected disabled>
                          Open this select menu
                        </option>
                        <option value='Male'>Male</option>
                        <option value='Female'>Female</option>
                      </select>
                    </div>
                  </div>

                  <div className='row'>
                    <div className='mb-3 col-md-6'>
                      <label for='exampleInputEmail1' className='form-label'>
                        First Name
                      </label>
                      <input
                        type='text'
                        className='form-control'
                        id='exampleInputEmail1'
                        aria-describedby='emailHelp'
                      />
                    </div>
                    <div className='mb-3 col-md-6'>
                      <label for='exampleInputEmail1' className='form-label'>
                        Last Name
                      </label>
                      <input
                        type='text'
                        className='form-control'
                        id='exampleInputEmail1'
                        aria-describedby='emailHelp'
                      />
                    </div>
                  </div>
                </div>
                <div className='container-fluid'>
                  <div className='row'>
                    <div className='col-md-7'>
                      <div className='mb-3'>
                        <label for='exampleInputEmail1' className='form-label'>
                          Hotel Name
                        </label>
                        <select
                          className='form-select form-control'
                          aria-label='Default select example'
                        >
                          <option selected disabled>
                            Open this select menu
                          </option>
                          <option value='Mr'>Residency Ogidi</option>
                          <option value='Mrs'>Residency Ajao</option>
                          <option value='Dr'>Residency Utako</option>
                          <option value='Chief'>Residency Area 1</option>
                        </select>
                      </div>
                    </div>
                    <div className='col-md-5'>
                      <div className='mb-3'>
                        <label for='exampleInputPassword1' className='form-label'>
                          Room Type
                        </label>
                        <select
                          className='form-select form-control'
                          aria-label='Default select example'
                        >
                          <option selected disabled>
                            Open this select menu
                          </option>
                          <option value='Mr'>Standard duluxe</option>
                          <option value='Mrs'>Presidential Suite</option>
                          <option value='Dr'>Executive Duluxe</option>
                          <option value='Chief'>Regular</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='container-fluid'>
                  <div className='row'>
                    <div className='col-md-4'>
                      <div className='mb-3'>
                        <label for='exampleInputEmail1' className='form-label'>
                          Room Number
                        </label>
                        <input
                          type='email'
                          className='form-control'
                          id='exampleInputEmail1'
                          aria-describedby='emailHelp'
                        />
                      </div>
                    </div>
                    <div className='col-md-8'>
                      <div className='mb-3'>
                        <label for='exampleInputPassword1' className='form-label'>
                          Type of Meal
                        </label>
                        <select
                          className='form-select form-control'
                          aria-label='Default select example'
                        >
                          <option selected disabled>
                            Open this select menu
                          </option>
                          <option value='Mr'>Chairman's Fish</option>
                          <option value='Mrs'>Rice and Stew</option>
                          <option value='Dr'>Ise Ewu</option>
                          <option value='Chief'>Spaghetti</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='container-fluid'>
                  <div className='row'>
                    <div className='col-md-4'>
                      <div className='mb-3'>
                        <label for='exampleInputEmail1' className='form-label'>
                          Quantity
                        </label>
                        <input
                          type='email'
                          className='form-control'
                          id='exampleInputEmail1'
                          aria-describedby='emailHelp'
                        />
                      </div>
                    </div>
                    <div className='col-md-8'>
                      <div className='mb-3'>
                        <label for='exampleInputPassword1' className='form-label'>
                          Phone Number
                        </label>
                        <input
                          type='text'
                          className='form-control'
                          id='exampleInputPassword1'
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='mb-3'>
                  <label for='exampleInputPassword1' className='form-label'>
                    Special Request
                  </label>
                  <div className='form-floating'>
                    <textarea
                      className='form-control'
                      placeholder='Leave a comment here'
                      id='floatingTextarea2'
                      style={{ height: "100px" }}
                    ></textarea>
                    <label for='floatingTextarea2'>Comments</label>
                  </div>
                </div>

                {/* <div className="mb-3 form-check">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1"/>
                    <label className="form-check-label" for="exampleCheck1">Check me out</label>
                </div> */}
                {/* <button type="submit" className="btn btn-primary">Submit</button> */}
              </form>
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-secondary'
                data-bs-dismiss='modal'
              >
                Cancel
              </button>
              <button
                type='button'
                className='btn btn-primary'
                data-bs-toggle='modal'
                data-bs-target='#staticBackdrop'
              >
                Order Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Restaurant;
